
import Vue from 'vue';
import { InfoStats } from '@descomplica/vue-components';
import { StudyPlanningBreakpointModel } from '@/models/studyPlanning/StudyPlanningBreakpointModel';
import { CourseModel } from '@descomplica/dex-models';
import { StudyPlanningModel } from '@/models/studyPlanning/StudyPlanningModel';
import {
  HOURS_PER_WEEK_STAT,
  LISTS_PER_WEEK_STAT,
  TOTAL_WEEKS_STAT,
} from '@/helpers/postgradStudyPlanning/constants';

interface StatsOption {
  quantity: number | null;
  label: string;
  icon: string;
}

export default Vue.extend({
  components: { InfoStats },
  props: {
    selectedNumberOfMonths: {
      type: Number,
      required: true,
    },
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    studyPlanning(): StudyPlanningModel | null {
      return this.$store.getters.studyPlanning(this.currentCourse.id);
    },
    studyPlanningBreakpoints(): StudyPlanningBreakpointModel[] {
      return this.$store.getters.studyPlanningBreakpoints;
    },
    breakpointStats(): StatsOption[] {
      const hoursPerWeek = HOURS_PER_WEEK_STAT;
      const listsPerWeek = LISTS_PER_WEEK_STAT;
      const totalWeeks = TOTAL_WEEKS_STAT;

      const currentStudyPlanningHoursPerWeek = this.studyPlanning?.selectedBreakpoint.hoursPerWeek;
      const currentStudyPlanningListsPerWeek = this.studyPlanning?.selectedBreakpoint.listsPerWeek;
      const currentStudyPlanningTotalWeeks = this.studyPlanning?.selectedBreakpoint.totalWeeks;

      const chosenOption = this.studyPlanningBreakpoints.find(
        (b) => b.numberOfMonths === this.selectedNumberOfMonths,
      );

      return [
        {
          ...hoursPerWeek,
          quantity: chosenOption?.hoursPerWeek || currentStudyPlanningHoursPerWeek || null,
        },
        {
          ...listsPerWeek,
          quantity: chosenOption?.listsPerWeek || currentStudyPlanningListsPerWeek || null,
        },
        {
          ...totalWeeks,
          quantity: chosenOption?.totalWeeks || currentStudyPlanningTotalWeeks || null,
        },
      ];
    },
  },
});
